import { Dispatch, useEffect } from 'react'
import { ActivityFilterItemById } from 'generated/graphql'
import {
  TIdsByDepth,
  TJobCategory,
} from '@app.feature/jobCategory/type/jobCategoryStoreType'
import useIsMobile from '@app.modules/hooks/useIsMobile'
import { Action, StateType } from '../context'

interface IFUseCategoryIdsSyncEffectParams {
  idsByDepth: TIdsByDepth
  getCategoriesByIds: (ids: string[]) => TJobCategory[]
  recruitContext: {
    state: StateType
    dispatch: Dispatch<Action>
  }
  showSelectedIds: string[]
}

const useCategoryIdsSyncEffect = (params: IFUseCategoryIdsSyncEffectParams) => {
  const { getCategoriesByIds, idsByDepth, recruitContext, showSelectedIds } =
    params
  const { state, dispatch } = recruitContext
  const isMobile = useIsMobile()

  // PC에서 context의 categoryIDs와 jobCategoryStore의 싱크를 맞추기 위함
  return useEffect(() => {
    if (isMobile) {
      return
    }
    if (idsByDepth[1]) {
      const firstCategories = getCategoriesByIds(idsByDepth[1])
      const needToggleItems: ActivityFilterItemById[] = []
      firstCategories.map((category) => {
        let isSelectedInContext = false
        for (const categoryId of state.filterBy.categoryIDs || []) {
          if (categoryId === category.id) {
            isSelectedInContext = true
            break
          }
        }
        if (
          (isSelectedInContext && !category.isSelect) ||
          (!isSelectedInContext && category.isSelect)
        ) {
          needToggleItems.push({
            __typename: 'ActivityFilterItemByID',
            id: category.id,
            name: category.name,
          })
        }
      })

      needToggleItems.map((item) => {
        dispatch({
          type: 'FILTER_BY_TOGGLE_FILTER_ITEM',
          listItem: item,
          fieldName: 'categoryIDs',
        })
      })
    }
  }, [showSelectedIds, isMobile])
}

export default useCategoryIdsSyncEffect
